import { LoginFormData, Me, LoginApiFormData, LoginApiFormErrors, LoginFormErrors, Auth } from '../types';
import { staticFileUrl } from '../../../shared/utils/url-maker';

export class MeMappers {
  public static meFromApi(raw: any): Me {
    return {
      id: raw.data.id,
      firstName: raw.data.user_name.split(' ')[0],
      lastName: raw.data.user_name.split(' ')[1],
      email: raw.data.email,
      phoneNumber: raw.data.number,
      emergencyModeIsEnabled: raw.data.emergency_mode === '1',
      profilePhoto: raw.data.filename ? staticFileUrl(raw.data.filename) : '/images/avatar.jpg',
      departments: raw.data.departments.map((item) => ({ id: item.warehouse_id, name: item.name })),
      birthDate: raw.data.birth_date,
      gender: raw.data.gender,
      permissions: raw.data.permissions.map(({ operation_id }) => operation_id),
    };
  }

  public static loginFormToApi(formData: LoginFormData): LoginApiFormData {
    return {
      username: formData.username,
      password: formData.password,
    };
  }

  public static loginFormErrorsFromApi(errors: LoginApiFormErrors): LoginFormErrors {
    return {
      username: errors.username,
      password: errors.password,
    };
  }

  public static loginFormSuccessFromApi(response: any): Auth {
    return {
      accessToken: response.access_token,
      refreshToken: response.refresh_token,
      tokenType: response.token_type,
      expiresIn: response.expires_in,
    };
  }
}
